import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Tabs, Tab, Divider, colors } from '@mui/material';

import axios from 'utils/axios';
import { Page, Header } from 'components';
import { Overview, Projects, Users } from './components';
import { GetOperator } from '../../actions/OperatorsActions';

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: '100%',
		margin: '0 auto',
		padding: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	divider: {
		backgroundColor: colors.grey[300],
	},
	alert: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
}));

const OperatorDetails = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [tab, setTab] = useState('overview');

	const operatorId = useSelector((state) => state.operatorsReducer.detailsOperatorId);
	const operator = useSelector((state) => state.operatorsReducer.operator);
	useEffect(() => {
		let mounted = true;

		const fetchoperator = () => {
			dispatch(GetOperator(operatorId));
		};

		fetchoperator();

		return () => {
			mounted = false;
		};
	}, [operatorId]);

	const handleTabsChange = (event, value) => {
		setTab(value);
	};

	const tabs = [
		{ value: 'overview', label: 'Overview' },
		{ value: 'projects', label: 'Projects' },
		{ value: 'users', label: 'Users' },
	];

	if (!tab) {
		return <Redirect to="/management/operators" />;
	}

	if (!tabs.find((t) => t.value === tab)) {
		return <Redirect to="/errors/error-404" />;
	}

	if (!operatorId) {
		return null;
	}

	return (
		<Page className={classes.root} title="Operator Details">
			<Header module="Management" view="Operator Details" />
			<Tabs
				className={classes.tabs}
				onChange={handleTabsChange}
				scrollButtons="auto"
				value={tab}
				variant="scrollable"
			>
				{tabs.map((item) => (
					<Tab key={item.value} label={item.label} value={item.value} />
				))}
			</Tabs>
			<Divider className={classes.divider} />
			<div className={classes.content}>
				{tab === 'overview' && <Overview operator={operator} />}
				{tab === 'projects' && <Projects operator={operator} />}
				{tab === 'users' && <Users users={operator.userList} />}
			</div>
		</Page>
	);
};

export default OperatorDetails;
